// extracted by mini-css-extract-plugin
module.exports = {"container":"average_container_2utM_","noDataBox":"average_noDataBox_2E_aZ","icon":"average_icon_3sqZi","chartBox":"average_chartBox_3VzLD"};